import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'app-kendo-textarea',
  templateUrl: './kendo-textarea.component.html',
  styleUrls: ['./kendo-textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KendoTextareaComponent),
      multi: true,
    },
  ],
})
export class KendoTextareaComponent implements ControlValueAccessor, OnInit {
  @Input() inputText: string; // input text value
  @Input() formControlName: string; // represents form control name
  @Input() inputType: string; // represents type of control
  @Input() parentForm: FormGroup; // represents form
  @Input() autofillValue = ''; // represents autofill values
  @Input() maxLength = 250;
  @Input() isReadOnly: boolean;
  value: string;
  characterCount: number;
  counter: string;

  public ngOnInit(): void {
    this.characterCount = this.value ? this.value.length : 0;
    this.counter = `${this.characterCount}/${this.maxLength}`;
  }

  onChange = (value: string) => {
    this.characterCount = value.length;
    this.counter = `${this.characterCount}/${this.maxLength}`;
  };
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
